import {
  all,
  call,
  getContext,
  put,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";

import {
  getScheduledPostsSuccess,
  getScheduledPostsFailure,
  getPortionScheduledSuccess,
  getPortionScheduledFailure,
  deleteScheduledPostSuccess,
  deleteScheduledPostFailure,
  editScheduledPostSuccess,
  editScheduledPostFailure,
} from "./actions";
import {
  getScheduledPostsActionTypes,
  getPortionScheduledActionTypes,
  deleteScheduledPostActionTypes,
  editScheduledPostActionTypes,
} from "./actionTypes";
import { CONTEXT } from "@const/redux";
import { normalizePost, normalizePostArray } from "@helpers/posts";
import { setAuthors } from "../authors/actions";
import { updateSubscriptions } from "../subscriptions/actions";

const getPostsAsync = ({ PostsService, params }) => {
  if (!PostsService) {
    return;
  }

  return PostsService.getMyScheduledPosts(params);
};

function* getScheduledPosts({ payload }) {
  try {
    const { PostsService } = yield getContext(CONTEXT.SERVICES);

    const { data, pagination } = yield call(getPostsAsync, {
      PostsService,
      params: payload,
    });

    const { entities, result: allPosts } = normalizePostArray(data);
    const { authors, subscriptions, posts: postById } = entities;

    const { totalCount, nextOffset } = pagination;

    yield all([
      put(setAuthors(authors)),
      put(updateSubscriptions({ subscriptions })),
      put(
        getScheduledPostsSuccess({
          allPosts,
          postById,
          totalCount,
          nextOffset,
        }),
      ),
    ]);
  } catch ({ error }) {
    yield put(getScheduledPostsFailure(error));
  }
}

function* getPortionScheduled({ payload }) {
  console.log("Saga Portion Params", payload);
  try {
    const { PostsService } = yield getContext(CONTEXT.SERVICES);

    const { data, pagination } = yield call(getPostsAsync, {
      PostsService,
      params: payload,
    });

    const { entities, result: allPosts } = normalizePostArray(data);
    const { authors, subscriptions, posts: postById } = entities;
    const { totalCount, nextOffset } = pagination;

    yield all([
      put(updateSubscriptions({ subscriptions })),
      put(setAuthors(authors)),
      put(
        getPortionScheduledSuccess({
          allPosts,
          postById,
          totalCount,
          nextOffset,
        }),
      ),
    ]);
  } catch ({ error }) {
    yield put(getPortionScheduledFailure(error));
  }
}

const deletePostAsync = ({ PostsService, id }) => {
  if (!PostsService) {
    return;
  }

  return PostsService.deletePostById(id);
};

function* deleteScheduledPost({ payload: { id } }) {
  try {
    const { PostsService } = yield getContext(CONTEXT.SERVICES);

    yield call(deletePostAsync, { PostsService, id });
    yield put(deleteScheduledPostSuccess({ id }));
  } catch ({ error }) {
    yield put(deleteScheduledPostFailure(error));
  }
}

const editPostAsync = ({ PostsService, id, ...body }) => {
  if (!PostsService) {
    console.log("Missing required service");
    return;
  }

  return PostsService.editPost(id, body);
};

function* editScheduledPost({ payload }) {
  try {
    const { PostsService } = yield getContext(CONTEXT.SERVICES);

    const { data } = yield call(editPostAsync, { PostsService, ...payload });
    const { result, entities } = normalizePost(data);
    const post = entities.posts[result];

    yield put(editScheduledPostSuccess({ post, result }));
  } catch (error) {
    yield put(editScheduledPostFailure());
  }
}

export function* watchGetScheduledPosts() {
  yield takeLatest(getScheduledPostsActionTypes.request, getScheduledPosts);
}

export function* watchGetScheduledPortion() {
  yield takeLatest(getPortionScheduledActionTypes.request, getPortionScheduled);
}

export function* watchDeleteScheduledPost() {
  yield takeEvery(deleteScheduledPostActionTypes.request, deleteScheduledPost);
}

export function* watchEditScheduledPost() {
  yield takeEvery(editScheduledPostActionTypes.request, editScheduledPost);
}
